const REGISTER_SOURCE_PARAM = 'register_source';

/**
 * Appends the current page's full URL as a `register_source` query parameter to
 * the given destination URL. This lets the registration app (portunus) reliably
 * know which landing page the user arrived from, even across origins where the
 * Referer header would otherwise be stripped to just the origin.
 */
const withSource = url => {
  if (typeof window === 'undefined' || !url) {
    return url;
  }

  const source = window.location.href;
  const separator = url.includes('?') ? '&' : '?';

  return `${url}${separator}${REGISTER_SOURCE_PARAM}=${encodeURIComponent(source)}`;
};

export default withSource;
